module.exports = __webpack_public_path__ + "static/media/kitchen_turquoise.af587759.png";